import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { SidePanelFreeFieldPermissionsSection } from "./SidePanelFreeFieldPermissionsSection";

interface FreeFieldPermissionProfileSidePanelDetailsProps {
  data: server.dto.FreeFieldProfileSidePanelData
  environment: server.dto.Environments
}

const getTitle = (mainArea: server.dto.MainAreas) => {
  switch (mainArea) {
    case "show":
      return site.currentEnvironment.show.singular;
    case "tour":
      return site.currentEnvironment.tour.singular;
    default:
      return "";
  }
}

export const FreeFieldPermissionProfileSidePanelDetails = (props: FreeFieldPermissionProfileSidePanelDetailsProps) => {
  const { freeFields, permissions, profile } = props.data;

  const environmentTypeTitle = profile.environment === "internal"
    ? RESX.UserType.InternalUsers
    : RESX.UserType.ExternalUsers;

  return <SidePanelDetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    fields={[{
      key: "name",
      label: RESX.GeneralLabels.Name,
      render: () => <span>{profile.title}</span>
    }, {
      key: "type",
      label: RESX.GeneralLabels.Type,
      render: () => <span>{environmentTypeTitle}</span>
    }]}
    additionalContent={<>
      {freeFields.map(freeFieldArea => <React.Fragment key={freeFieldArea.mainArea}>
        <h3>{getTitle(freeFieldArea.mainArea)}</h3>
        <SidePanelFreeFieldPermissionsSection
          environment={props.environment}
          categories={freeFieldArea.categories}
          permissions={permissions}
        />
      </React.Fragment>)}
    </>}
  />
}